import _ from 'lodash';
import io from 'socket.io-client';
import SimplePeer from 'simple-peer/simplepeer.min.js';
import { connect } from 'react-redux';
import { createNotification } from 'react-redux-notify';
import React, { createContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TokenStorage from '../storage/token';
import { Face2FaceEvents } from '../socket/events';
import FaceToFaceService from '../services/f2f/session';
import Face2FaceService from '../utils/formatTimeToMin';
import ICEServerService from '../services/f2f/iceServer';
import PermissionService from '../services/f2f/permission';
import { f2fsession, fetchF2FPendingCallsStart } from '../../store/actions/Face2FaceAction';
import { getErrorNotificationMessage } from '../../components/helper/NotificationMessage';
import { getSuccessNotificationMessage } from '../../components/helper/NotificationMessage';
import { appConfig } from '../../config';

let socket;
const url = appConfig.f2fSocketHost || '';

export const SocketContext = createContext({});

function SocketProvider({ children, session, ...props }) {
  const peerRef = useRef();
  const navigate = useNavigate();
  const reConnectRef = useRef(null);
  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);
  const sessionDataRef = useRef(null);
  const statsIntervalRef = useRef(null);
  const isCallDisconnectingRef = useRef(false);
  const reasonForCallEndingRef = useRef(null);

  const [connected, setConnected] = useState(false);
  const [showCallNotification, setCallNotification] = useState(false);
  const [localStream, setLocalStream] = useState(null);
  const [remoteStream, setRmoteStream] = useState(null);
  const [callUserDecline, setUserCallDeclien] = useState(true);
  const [callStatus, setCallStatus] = useState('idle');
  const [peerConnection, setPeerConnection] = useState(null);
  const [isMuted, setIsMuted] = useState(false);
  const [isVideoHidden, setIsVideoHidden] = useState(false);
  const [isCallAccepted, setCallAccepted] = useState(false);
  const [currentSessionId, setCurrentSessionId] = useState(null);
  const [startTime, setStartTime] = useState(false);
  const [extendedCallTime, setExtenCallTime] = useState(null);
  const [isConnecting, setIsConnecting] = useState(false);
  const [isSpeaker, setIsSpeaker] = useState(false);
  const [facingMode, setfacingMode] = useState('user');
  const [remaingTime, setRemaningTime] = useState(null);
  const [userType, setUserType] = useState(null);
  const [conmectionStatusoffline, setConnectionStatusOffline] = useState(false);
  const [showCallDisconnectModal, setShowCallDisconnectModal] = useState(false);
  const [showCallDisconnectModalTime, setShowCallDisconnectModalTime] = useState(null);
  const [callCallDisconnectedWatingTime, setCallDisconnectedWaiting] = useState(null);
  const [sessionDataSave, setSessionDataSave] = useState(null);
  const [isSwitchFeed, setIsSwitchFeed] = useState(false);
  const [userActiveVideoStatus, setUserIsActiveVideoStatus] = useState(true);
  const [performerActiveVideoStatus, setPerformerIsActiveVideoStatus] = useState(true);
  const [showConnectModalUser, setShowConnectModalUser] = useState(false);
  const [showConnectModalPerformer, setShowConnectModalPerformer] = useState(false);
  const [remainingTimeOfUser, setRemainingTimeUser] = useState(null);
  const [isMediaPermissionUser, setIsMediaPermissionUser] = useState(true);
  const [hasAllPermission, setHasAllPermission] = useState(true);
  const [showSendMessageModal, setShowSendMessageModal] = useState(false);
  const [startUserTimer, setStartUserTimer] = useState(false);
  const [starPerformerTimer, setStartPerformerTimer] = useState(false);
  const handlePermissionModal = (message) => {
    setIsCallPermissionModalOpen({
      isOpen: true,
      message: message,
    });
  };

  const [isCallPermissionModalOpen, setIsCallPermissionModalOpen] = useState({
    isOpen: false,
    message: null,
  });

  const hasUserActiveRef = useRef(false);
  const hasPerformerActiveRef = useRef(false);
  const [showWaitingModal, setShowWitingModal] = useState(false);
  const [callAccepted, setIsCallAccepted] = useState(false);

  const [isMessageNotification, setIsMessageNotification] = useState({
    isOpen: false,
    data: {},
  });

  const [callExtendRequestData, setCallExtendRequest] = useState({
    isOpen: false,
    package: {},
    callerData: {},
    price: 0,
  });

  const [callPermisionDenied, setCallPermisionDenied] = useState({
    isOpen: false,
    message: 'Camera & microphone  permission is required',
  });

  const videoQuality = {
    video: {
      width: { ideal: 1280 },
      height: { ideal: 720 },
      frameRate: { ideal: 30 },
      facingMode: 'user',
    },
    audio: {
      echoCancellation: true,
      // noiseSuppression: true, // no suported in ios
      // sampleRate: 32000, // not suppoerted in firefox
      // sampleSize: 20,// not suppoerted in firefox
      // autoGainControl: true // not supported in ios
    },
  };

  const connect = () => {
    console.log('[Face2Face]: Creating socket connection...');
    socket = io(`${url}?token=${TokenStorage.getToken()}`, {
      secure: true,
      reconnection: true,
      transports: ['websocket'],
      timeout: 15000,
      pingTimeout: 15000,
      pingInterval: 45000,
      reconnectionDelay: 1000,
    });

    socket.on('connect', () => {
      setConnected(true);
    });

    socket.on('error', () => {
      setConnected(false);
    });

    socket.on(Face2FaceEvents.INITIALIZE_SESSION_RESPONSE, async (payload) => {
      if (Number(payload.receiver_id) == localStorage.getItem('userId')) {
        props.dispatch(f2fsession({}));
        props.dispatch(fetchF2FPendingCallsStart({}));

        socket.emit(Face2FaceEvents.INITIALIZE_SESSION_RECEIVED_BY_PERFORMER, {
          sessionId: payload.id,
        })

        const data = await FaceToFaceService.getPendingSession();
        if (data?.length == 1) {
          window.location.href = `/call-f2f?session=${data[0]?.id}`;
        } else {
          setCallNotification(true);
          saveToLocalStorage('isCallAccepted', true);
        }
      }
    });

    socket.on(Face2FaceEvents.CALL_DECLINE_BY_PERFORMER_RESPONSE_FOR_USER, (payload) => {
      if (Number(payload.caller_id) == localStorage.getItem('userId')) {
        setUserCallDeclien(false);
      }
    });

    socket.on(Face2FaceEvents.SEND_VEDIO_STREAM_TO_USER, (payload) => {
      if (Number(payload.to) == localStorage.getItem('userId')) {
        setCallAccepted(true);
        setShowWitingModal(false);
        setShowCallDisconnectModal(false);
        setUserIsActiveVideoStatus(true);
        startCameraUserSide(payload.sessionId, payload.signal, payload.IceUrls);
      }
    });

    socket.on(Face2FaceEvents.DISCONNECT_CALL_FROM_PERFORMER_SIDE_WHEN_USER_INACTIVE, (payload) => {
      if (Number(payload.to) == localStorage.getItem('userId')) {
        peerDestroy();
        endCallAutomatic();
        props.dispatch(createNotification(getSuccessNotificationMessage('Call Ended')));
      }
    });

    socket.on(Face2FaceEvents.SEND_REPORT_AND_END_CALL_BY_USER, (payload) => {
      peerDestroy();
      endCallAutomatic();
      props.dispatch(createNotification(getSuccessNotificationMessage('Call Ended')));
    });

    socket.on(Face2FaceEvents.DISCONNECT_CALL_FROM_USER_SIDE_WHEN_PERFORMER_INACTIVE, () => {
      peerDestroy();
      endCallAutomatic();
      props.dispatch(createNotification(getSuccessNotificationMessage('Call Ended')));
    });

    socket.on(Face2FaceEvents.CALL_EXTEND_REQUEST_BY_USER, (payload) => {
      if (Number(payload.to) == localStorage.getItem('userId')) {
        setCallExtendRequest({
          isOpen: true,
          package: payload.package_detail,
          callerData: payload.callerData,
          price: payload.price,
        });
      }
    });

    socket.on(Face2FaceEvents.CALL_EXTEND_REQUEST_DICLINE_BY_PERFORMER, (payload) => {
      if (Number(payload.to) == localStorage.getItem('userId')) {
        props.dispatch(createNotification(getErrorNotificationMessage(payload.message)));
      }
    });

    socket.on(Face2FaceEvents.SET_USER_CALL_SCREEN_STATUS, (payload) => {
      setUserIsActiveVideoStatus(payload.isActive);
      setShowWitingModal(!showWaitingModal);
    });

    socket.on(Face2FaceEvents.USER_CONNECTING_SCREEN_STATUS_SEND_BY_PERFORMER, (payload) => {
      setIsConnecting(payload.isConnecting);
      setRemainingTimeUser(payload.remaining_time);
    });

    socket.on(Face2FaceEvents.SET_PERFORMER_CALL_SCREEN_STATUS, (payload) => {
      setPerformerIsActiveVideoStatus(payload.isActive);
      setShowWitingModal(!showWaitingModal);
    });

    socket.on(Face2FaceEvents.START_USER_TIMER, (payload) => {
      setStartUserTimer(payload.startUserTimer)
    });

    socket.on(Face2FaceEvents.USER_MEDIA_PERMISSION_STATUS_SEND_TO_PERFORMER, (payload) => {
      setIsMediaPermissionUser(payload.mediaPermission);
    });

    socket.on(Face2FaceEvents.SEND_F2F_TIP_NOTIFICATION_TO_PERRFORMER, (payload) => {
      payload.paymentId && props.dispatch(
        createNotification(getSuccessNotificationMessage('Tip Received From User')),
      );
    });

    socket.on(
      Face2FaceEvents.CALL_EXTEND_REQUEST_ACCEPT_BY_PERFORMER_RESPONSE_TO_USER,
      (payload) => {
        if (Number(payload.to) == localStorage.getItem('userId')) {
          setCallExtendRequest({
            isOpen: false,
            package: {},
            callerData: {},
          });
          setExtenCallTime(payload.extended_time);
          props.dispatch(
            createNotification(getSuccessNotificationMessage('Call Extend Succesfully')),
          );
        }
      },
    );

    socket.on(Face2FaceEvents.UNACCEPTED_CALL_CUTBY_USER_FOR_PERFORMER, (payload) => {
      if (Number(payload.to) == localStorage.getItem('userId')) {
        if (window.location.pathname.startsWith('/call-f2f')) {
          props.dispatch(
            createNotification(getSuccessNotificationMessage('Call Cancelled By User')),
          );

          window.location.href = '/face2face';
        } else {
          props.dispatch(f2fsession({}));
        }
      }
    });

    socket.on(Face2FaceEvents.CALL_REQUEST_TIMED_OUT_TO_PERFORMER, (payload) => {
      if (Number(payload.to) == localStorage.getItem('userId')) {
        props.dispatch(createNotification(getErrorNotificationMessage('Call Cancelled')));
        if (window.location.pathname.startsWith('/call-f2f')) {
          window.location.href = '/face2face';
          props.dispatch(fetchF2FPendingCallsStart({}));
        } else {
          props.dispatch(f2fsession({}));
        }
      }
    });

    socket.on(Face2FaceEvents.CALL_IS_ENDING_ACKNOWLEDGMENT, (payload) => {
      props.dispatch(fetchF2FPendingCallsStart({}));
      if (Number(payload.to) == localStorage.getItem('userId')) {
        isCallDisconnectingRef.current = true
        reasonForCallEndingRef.current = payload.message
        socket.emit(Face2FaceEvents.CALL_IS_ENDING_ACKNOWLEDGMENT_RECEIVED, payload)
      }
    });

    socket.on(Face2FaceEvents.CLOSE_FACE2FACE_CALL, (payload) => {
      if (Number(payload.to) == localStorage.getItem('userId')) {
        props.dispatch(
          createNotification(getSuccessNotificationMessage(reasonForCallEndingRef.current)),
        );
        peerDestroy()
        endCallAutomatic();
      }
    })

    socket.on(Face2FaceEvents.SESSION_RECONNECT_CALL_FORM_USER_SIDE_RESPONSE_TO_USER, (payload) => {
      if (Number(payload.to) == localStorage.getItem('userId')) {
        props.dispatch(createNotification(getSuccessNotificationMessage('Call Reconnecting')));
        setStartTime(false);
        setIsConnecting(true);
        if (!callCallDisconnectedWatingTime) {
          handleaddTimeToWaiting();
        }
      }
    });

    socket.on(
      Face2FaceEvents.SESSION_RECONNECT_CALL_FORM_USER_SIDE_RESPONSE_TO_PERFORMER,
      (payload) => {
        if (Number(payload.to) == localStorage.getItem('userId')) {
          props.dispatch(
            createNotification(
              getSuccessNotificationMessage('Caller  disconnected re-connecting call '),
            ),
          );
          window.location.reload();
        }
      },
    );

    socket.on(
      Face2FaceEvents.CAMERA_PERMISSION_ERROR_IN_CALLER_SIDE_RESPONSE_TO_RECEIVER,
      (payload) => {
        if (Number(payload.to) == localStorage.getItem('userId')) {
          endCallAutomaticWhenErrorOccuredInCallerSide(payload.message);
        }
      },
    );

    socket.on(
      Face2FaceEvents.SEND_MESSAGE_TO_USER_BY_PERFORMER_SEND_RESPONSE_TO_USER,
      (payload) => {
        if (Number(payload.to) == localStorage.getItem('userId')) {
          setIsMessageNotification({
            isOpen: true,
            data: {
              receiver_id: payload.from,
              caller_id: payload.to,
              session_id: payload.sessionId,
            },
          });
        }
      },
    );

    socket.on(Face2FaceEvents.ERROR, (payload) => {
      const { error } = payload;
      if (error) {
        if (error?.payload?.error && _.isString(error.payload.error)) {
          props.dispatch(createNotification(getErrorNotificationMessage(error.payload.error)));
        } else {
          props.dispatch(createNotification(getErrorNotificationMessage('Something went wrong!')));
        }
      }
    });

    socket.on(Face2FaceEvents.CHECK_PERFORMER_ACTIVE_ON_CALL_STATUS, (payload) => {
      setCallAccepted(true)
      setIsCallAccepted(true);
      setIsConnecting(true);
      setShowWitingModal(false);
      setShowCallDisconnectModal(false);
      saveToLocalStorage('sessionId', payload?.sessionId);
      setCurrentSessionId(payload?.sessionId)
    });
  };

  useEffect(() => {
    const session_data = JSON.parse(localStorage.getItem('session_data')) || {};
    const settingData = session?.single_session?.data?.data?.settings;
    if (
      session?.single_session?.data?.data &&
      session_data.userType == 'recevier' &&
      isCallAccepted
    ) {
      if (settingData?.receiver) {
        setIsVideoHidden(settingData?.receiver?.isVideoHidden);
        setIsMuted(settingData?.receiver?.isMuted);
        setIsSpeaker(settingData?.receiver?.isSpeaker);
        setfacingMode(settingData?.receiver?.facing_mode);
      }
    } else {
      if (settingData?.caller) {
        setIsVideoHidden(settingData?.caller?.isVideoHidden);
        setIsMuted(settingData?.caller?.isMuted);
        setIsSpeaker(settingData?.caller?.isSpeaker);
        setfacingMode(settingData?.caller?.facing_mode);
      }
    }
  }, [session?.single_session?.data]);

  useEffect(() => {
    if (!localStream) return;

    localStream.getAudioTracks().forEach((track) => {
      if (track.readyState === 'live') {
        track.enabled = !isMuted;
      }
    });
    localStream.getVideoTracks().forEach((track) => {
      if (track.readyState === 'live') {
        track.enabled = !isVideoHidden;
      }
    });
  }, [localStream, isMuted, isVideoHidden]);

  useEffect(() => {
    const session_data = JSON.parse(localStorage.getItem('session_data')) || {};
    if (!remoteStream && session_data.userType == 'recevier') {
      if (Object.keys(session_data).length > 0) {
        if (
          socket &&
          session_data.isCallAccepted &&
          session_data.currentSessionId &&
          session_data.callStatus &&
          session_data.isPeerConnected
        ) {
          if (!callCallDisconnectedWatingTime) {
            handleaddTimeToWaiting();
          }
          reconnectPeer(
            session_data.isPeerConnected,
            session_data.callStatus,
            session_data.currentSessionId,
          );
          reConnectRef.current = setInterval(() => {
            if (!remoteStream) {
              reconnectPeer(
                session_data.isPeerConnected,
                session_data.callStatus,
                session_data.currentSessionId,
              );
            }
          }, 7000);
        }
      }
    }
  }, [socket]);

  useEffect(() => {
    const session_data = JSON.parse(localStorage.getItem('session_data')) || {};
    if (!remoteStream && session_data.userType == 'caller') {
      if (Object.keys(session_data).length > 0) {
        if (
          socket &&
          session_data.callStatus == 'ongoing' &&
          session_data.currentSessionId &&
          session_data.isPeerConnected
        ) {
          socket.emit(Face2FaceEvents.SESSION_RECONNECT_CALL_FORM_USER_SIDE, {
            sessionId: session_data.currentSessionId,
          });
        }
      }
    }
  }, [socket]);

  useEffect(() => {
    sessionDataRef.current = {
      currentSessionId,
      remaingTime,
    };
  }, [currentSessionId, remaingTime]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (callCallDisconnectedWatingTime && isConnecting && !startTime) {
        const [minutes, seconds] = callCallDisconnectedWatingTime.split(':').map(Number);
        const newSeconds = seconds - 1;

        if (newSeconds < 0) {
          const newMinutes = minutes - 1;
          if (newMinutes < 0) {
            clearInterval(interval);
          } else {
            setCallDisconnectedWaiting(`${newMinutes.toString().padStart(2, '0')}:59`);
          }
        } else {
          setCallDisconnectedWaiting(
            `${minutes.toString().padStart(2, '0')}:${newSeconds.toString().padStart(2, '0')}`,
          );
        }
        // Show an alert every 5 seconds
        if (minutes === 0 && newSeconds === 0) {
          setShowCallDisconnectModal(true);
          setCallDisconnectedWaiting(null);
          sessionDataSave && sessionDataSave.id && socket.emit(Face2FaceEvents.FACE2FACE_CALL_DISCONNECT_COUNTDOWN_POPUP_SHOWN, {
            sessionId: sessionDataSave.id,
          });
          setShowCallDisconnectModalTime(
            Face2FaceService.secondsToMMSS(sessionDataSave?.call_end_countdown),
          );
        }
      } else {
        clearInterval(interval);
        if (!isConnecting && callCallDisconnectedWatingTime) {
          setShowCallDisconnectModalTime(null);
          setCallDisconnectedWaiting(null);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [callCallDisconnectedWatingTime, startTime, isConnecting]);

  useEffect(() => {
    if (isConnecting) {
      handleaddTimeToWaiting();
    }
  }, [isConnecting]);

  const handleStatusChange = (statusRef, status, successMessage) => {
    // Only show notifications if we're actually in a call session
    if (statusRef.current && status && currentSessionId) {
      setShowWitingModal(false);
      props.dispatch(createNotification(getSuccessNotificationMessage(successMessage)));
    }
    if (!status && currentSessionId) {
      setShowWitingModal(true);
    }
    statusRef.current = true;
  };

  useEffect(() => {
    handleStatusChange(hasUserActiveRef, userActiveVideoStatus, 'Call resuming');
  }, [userActiveVideoStatus]);

  useEffect(() => {
    handleStatusChange(hasPerformerActiveRef, performerActiveVideoStatus, 'Call resuming');
  }, [performerActiveVideoStatus]);

  const handleAcknowledgementError = (error) => {
    if (error?.payload?.error && _.isString(error.payload.error)) {
      props.dispatch(createNotification(getErrorNotificationMessage(error.payload.error)));
    } else {
      props.dispatch(createNotification(getErrorNotificationMessage('Something went wrong!')));
    }
  }

  const endCallFromPerformerWhenUserInactive = (payload) => {
    socket.emit(Face2FaceEvents.DISCONNECT_CALL_FROM_PERFORMER_SIDE_WHEN_USER_INACTIVE, payload, (error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        isCallDisconnectingRef.current = true
        props.dispatch(createNotification(getSuccessNotificationMessage('Call Endded Successfully')));
        endCallAutomatic();
      }
    });
  };

  const endCallFromUserWhenPerformerInactive = (payload) => {
    socket.emit(Face2FaceEvents.DISCONNECT_CALL_FROM_USER_SIDE_WHEN_PERFORMER_INACTIVE, payload, (error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        isCallDisconnectingRef.current = true
        props.dispatch(createNotification(getSuccessNotificationMessage('Call Endded Successfully')));
        endCallAutomatic();
      }
    });
  };

  const saveToLocalStorage = (key, value) => {
    const storeData = JSON.parse(localStorage.getItem('session_data')) || {};
    storeData[key] = value;
    localStorage.setItem('session_data', JSON.stringify(storeData));
  };

  const hanleInitializeCall = (payload) => {
    socket.emit(Face2FaceEvents.INITIALIZE_SESSION, payload, (sessionId, error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        navigate(`/user-call-f2f?session=${sessionId}`);
        props.dispatch(createNotification(getSuccessNotificationMessage('Call Initiated')));
      }
    });
  };

  const callDeclineByPerformer = (payload) => {
    socket.emit(Face2FaceEvents.CALL_DECLINE_BY_PERFORMER, payload, (error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        props.dispatch(f2fsession({}));
        props.dispatch(createNotification(getSuccessNotificationMessage('Face2Face Call Decline')));
        window.location.pathname !== '/face2face' && navigate("/face2face?type=All")
      }
    });
  };

  useEffect(() => {
    if (performerActiveVideoStatus) {
      if (!showConnectModalPerformer && !isCallPermissionModalOpen.isOpen) {
        startPerfomerCameraAfterVideoStatus();
      } else if (showConnectModalPerformer) {
        props.dispatch(
          createNotification(
            getSuccessNotificationMessage('User is waiting in the call.'),
          ),
        );
      }
    }
  }, [performerActiveVideoStatus]);

  const startCameraPerofmer = async (id) => {
    try {
      const session_data = JSON.parse(localStorage.getItem('session_data')) || {};
      const constraints = { ...videoQuality };
      constraints.video.facingMode = session_data?.setting?.performer?.facing_mode || facingMode;
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      setIsConnecting(true);

      if (
        session_data?.isCallAccepted &&
        session_data?.currentSessionId &&
        session_data?.setting?.receiver
      ) {
        const audioTracks = stream.getAudioTracks();
        const videoTracks = stream.getVideoTracks();
        // Disable audio tracks

        audioTracks.forEach((track) => {
          track.enabled = !session_data?.setting?.receiver?.isMuted;
          if (!session_data?.setting?.receiver?.isMuted) {
            track.applyConstraints({ echoCancellation: true });
          }
        });

        // Disable video tracks
        videoTracks.forEach((track) => {
          track.enabled = !session_data?.setting?.receiver?.isVideoHidden;
        });
      }

      setLocalStream(stream);
      setCurrentSessionId(id);
      saveToLocalStorage('currentSessionId', id);
      setUserType('recevier');
      saveToLocalStorage('userType', 'recevier');
      if (localVideoRef.current) {
        localVideoRef.current.srcObject = stream;
        initiateCallF2FConection(id, stream);
      }
    } catch (error) {
      console.error('Error starting camera:', error);
      if (error.message == 'Permission denied') {
        handleCameraPermissionDeniedInRecevierSide(`Camera ${error.message}`, id);
      }
    }
  };

  const startPerfomerCameraAfterVideoStatus = async () => {
    try {
      const session_data = (await JSON.parse(localStorage.getItem('session_data'))) || {};
      if (!callCallDisconnectedWatingTime) {
        handleaddTimeToWaiting();
      }
      reconnectPeer(
        session_data.isPeerConnected,
        session_data.callStatus,
        session_data.currentSessionId,
      );
      reConnectRef.current = setInterval(() => {
        if (!remoteStream) {
          reconnectPeer(
            session_data.isPeerConnected,
            session_data.callStatus,
            session_data.currentSessionId,
          );
        }
      }, 7000);
    } catch (error) {
      props.dispatch(
        createNotification(getErrorNotificationMessage('Error in reconnecting peers')),
      );
    }
  };

  const startCameraUserSide = async (id, performerStream, iceServers) => {
    try {
      const session_data = JSON.parse(localStorage.getItem('session_data')) || {};

      const constraints = { ...videoQuality };
      constraints.video.facingMode = session_data?.setting?.user?.facing_mode || facingMode; // Switch between 'user' and 'environment'
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      setIsConnecting(true);
      if (
        session_data?.isPeerConnected &&
        session_data?.currentSessionId &&
        session_data?.setting?.caller
      ) {
        const audioTracks = stream.getAudioTracks();
        const videoTracks = stream.getVideoTracks();

        audioTracks.forEach((track) => {
          track.enabled = !session_data?.setting?.caller?.isMuted;
          if (!session_data?.setting?.caller?.isMuted) {
            track.applyConstraints({ echoCancellation: true });
          }
        });

        videoTracks.forEach((track) => {
          track.enabled = !session_data?.setting?.caller?.isVideoHidden;
        });
      }
      setLocalStream(stream);
      setCurrentSessionId(id);
      saveToLocalStorage('currentSessionId', id);
      setUserType('caller');
      saveToLocalStorage('userType', 'caller');
      localVideoRef.current.srcObject = stream;
      acceptCall(id, stream, performerStream, iceServers);
    } catch (error) {
      console.error('Error starting camera:', error);
      handleCameraPermissionDeniedInCallerSide(`Camera ${error.message}`, id);
    }
  };

  const initiateCallF2FConection = async (id, onwStream) => {
    if (peerRef.current) {
      try {
        if (typeof peerRef.current.destroy === 'function') {
          try {
        if (typeof peerRef.current.destroy === 'function') {
          await peerRef.current.destroy();
        }
      } catch (error) {
        console.warn('Error destroying peer:', error);
      }
        }
      } catch (error) {
        console.warn('Error destroying peer:', error);
      }
      peerRef.current = null;
    }

    const iceServers = await ICEServerService.getIceServersData();
    // Create peer connection
    const peer = new SimplePeer({
      initiator: true,
      trickle: false,
      stream: onwStream,
      config: { iceServers: iceServers },
    });
    peerRef.current = peer;
    // Set up signaling
    peer.on('signal', (data) => {
      if (data?.type == 'offer') {
        saveToLocalStorage('performerStream', data);
        socket.emit(Face2FaceEvents.SEND_VEDIO_STREAM_TO_USER, {
          sessionId: id,
          signal: data,
          IceUrls: iceServers,
        });
      }
    });

    // Handle remote stream
    peer.on('stream', (stream) => {
      setRmoteStream(stream);
      remoteVideoRef.current.srcObject = stream;
    });
    peer.on('error', (err) => {
      if (isCallDisconnectingRef.current) return false
      setStartTime(false);
      const payload = {
        message: `Error Occure Caller Side. Error: ${err.message}`,
        sessionId: sessionDataRef.current.currentSessionId,
        remaingTime: sessionDataRef.current.remaingTime,
      };
      socket.emit(Face2FaceEvents.LOG_FACE_2_FACE_ERROR, payload);
      // window.location.reload();
      props.dispatch(createNotification(getErrorNotificationMessage('Caller disconnected !')));
      if (!conmectionStatusoffline) {
        setIsConnecting(true);
      }
      handleaddTimeToWaiting();
    });

    peer._pc.oniceconnectionstatechange = () => {
      if (peer._pc.iceConnectionState === 'disconnected' || peer._pc.iceConnectionState === 'failed') {
        setStartTime(false);
        if (!conmectionStatusoffline) {
          setIsConnecting(true);
        }
      }
    }

    socket.on(Face2FaceEvents.SEND_USER_VEDIO_STREAM_TO_PERFORMER, (payload) => {
      if (Number(payload.to) == localStorage.getItem('userId')) {
        setCallAccepted(true);
        saveToLocalStorage('isCallAccepted', true);
        setStartTime(true);
        setIsConnecting(false);
        setPerformerIsActiveVideoStatus(true);
        saveToLocalStorage('isPeerConnected', true);
        if (peer && !peer.destroyed) {
          peer.signal(payload.signal);
          clearInterval(reConnectRef.current);
        }
      }
    });

    setPeerConnection(peer);
    setCallStatus('calling');
    saveToLocalStorage('callStatus', 'calling');
  };

  const acceptCall = async (sessionId, onwStream, performerStream, iceServers) => {
    if (peerRef.current) {
      try {
        if (typeof peerRef.current.destroy === 'function') {
          await peerRef.current.destroy();
        }
      } catch (error) {
        console.warn('Error destroying peer:', error);
      }
      peerRef.current = null;
    }

    if (peerRef.current && !peerRef.current.destroyed) {
      try {
        if (typeof peerRef.current.destroy === 'function') {
          await peerRef.current.destroy();
        }
      } catch (error) {
        console.warn('Error destroying peer:', error);
      }
    }
    const peer = new SimplePeer({
      initiator: false,
      trickle: false,
      stream: onwStream,
      config: { iceServers: iceServers },
    });
    peerRef.current = peer;
    peer.on('signal', (data) => {
      socket.emit(Face2FaceEvents.SEND_USER_VEDIO_STREAM_TO_PERFORMER, { sessionId, signal: data });
    });

    peer.on('stream', (stream) => {
      setRmoteStream(stream);
      remoteVideoRef.current.srcObject = stream;
      setStartTime(true);
      setIsConnecting(false);
    });
    peer.on('error', (err) => {
      if (isCallDisconnectingRef.current) return
      setStartTime(false);
      if (!conmectionStatusoffline) {
        setIsConnecting(true);
      }
      const payload = {
        message: `Error Occure Receiver Side. Error: ${err.message}`,
        sessionId: sessionDataRef.current.currentSessionId,
        remaingTime: sessionDataRef.current.remaingTime,
      };
      socket.emit(Face2FaceEvents.LOG_FACE_2_FACE_ERROR, payload);
      handleaddTimeToWaiting();
      props.dispatch(createNotification(getErrorNotificationMessage('Receiver disconnected !')));
    });

    peer._pc.oniceconnectionstatechange = () => {
      if (peer._pc.iceConnectionState === 'disconnected' || peer._pc.iceConnectionState === 'failed') {
        setStartTime(false);
        if (!conmectionStatusoffline) {
          setIsConnecting(true);
        }
      }
    }

    peer.signal(performerStream);
    setIsConnecting(false);
    saveToLocalStorage('isPeerConnected', true);
    setPeerConnection(peer);
    setCallStatus('ongoing');
    saveToLocalStorage('callStatus', 'ongoing');
  };

  const endCallByPerformer = (payload, toggle) => {
    socket.emit(Face2FaceEvents.CALL_END_BY_PERFORMER, payload, (error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        toggle(false);
        setShowConnectModalPerformer(false);
        isCallDisconnectingRef.current = true
        reasonForCallEndingRef.current = 'Call Ended Successfully'
      }
    });
  };

  const endCallTimeComplete = (payload) => {
    socket.emit(Face2FaceEvents.CALL_DISCONNECTED_TIME_UP, payload, (error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        isCallDisconnectingRef.current = true
        reasonForCallEndingRef.current = 'Time Up! Call Disconected'
      }
    });
  };

  const peerDestroy = () => {
    if (peerConnection) {
      try {
        if (typeof peerConnection.destroy === 'function') {
          try {
        if (typeof peerConnection.destroy === 'function') {
          peerConnection.destroy();
        }
      } catch (error) {
        console.warn('Error destroying peer connection:', error);
      }
        }
      } catch (error) {
        console.warn('Error destroying peer connection:', error);
      }
    }
  };

  const endCallAutomatic = () => {
    if (localStream) {
      localStream.getTracks().forEach((track) => track.stop());
    }
    setLocalStream(null);
    setRmoteStream(null);
    setPeerConnection(null);
    setCallStatus('idle');
    setIsMuted(false);
    setIsVideoHidden(false);
    setCurrentSessionId(null);
    setStartTime(false);
    setExtenCallTime(null);
    setIsMessageNotification(false);
    setCallExtendRequest({
      isOpen: false,
      package: {},
      callerData: {},
    });
    setConnectionStatusOffline(false);
    setIsConnecting(false);
    setShowCallDisconnectModal(false);
    setShowCallDisconnectModalTime(null);
    setCallDisconnectedWaiting(null);
    setIsSwitchFeed(false);
    setCallAccepted(false);
    localStorage.setItem('session_data', JSON.stringify({}));
    window.location.href = '/face2face';
  };

  const handleUpadteRemaingTime = (payload) => {
    socket.emit(Face2FaceEvents.UPDATE_REMANING_TIME_AFTER_5_SEC, payload);
  };

  const checkActiveTabOfPerformer = (payload) => {
    if (peerRef.current && !payload.isActive) {
      try {
        if (typeof peerRef.current.destroy === 'function') {
          peerRef.current.destroy();
        }
      } catch (error) {
        console.warn('Error destroying peer:', error);
      }
      peerRef.current = null;
    }
    if (peerConnection) {
      try {
        if (typeof peerConnection.destroy === 'function') {
          try {
        if (typeof peerConnection.destroy === 'function') {
          peerConnection.destroy();
        }
      } catch (error) {
        console.warn('Error destroying peer connection:', error);
      }
        }
      } catch (error) {
        console.warn('Error destroying peer connection:', error);
      }
    }
    socket.emit(Face2FaceEvents.SET_USER_CALL_SCREEN_STATUS, payload);
  };

  const startUserTimerWithPerformer = (payload) => {
    socket.emit(Face2FaceEvents.START_USER_TIMER, payload, (status, error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        setStartPerformerTimer(status);
      }
    });
  };

  const checkPerformerConnectingStatus = (payload) => {
    socket.emit(Face2FaceEvents.USER_CONNECTING_SCREEN_STATUS_SEND_BY_PERFORMER, payload);
  };

  const checkActiveTabOfUsers = (payload) => {
    if (peerRef.current && !payload.isActive) {
      try {
        if (typeof peerRef.current.destroy === 'function') {
          peerRef.current.destroy();
        }
      } catch (error) {
        console.warn('Error destroying peer:', error);
      }
      peerRef.current = null;
    }
    if (peerConnection) {
      try {
        if (typeof peerConnection.destroy === 'function') {
          try {
        if (typeof peerConnection.destroy === 'function') {
          peerConnection.destroy();
        }
      } catch (error) {
        console.warn('Error destroying peer connection:', error);
      }
        }
      } catch (error) {
        console.warn('Error destroying peer connection:', error);
      }
    };
    socket.emit(Face2FaceEvents.SET_PERFORMER_CALL_SCREEN_STATUS, payload);
  };

  const handleSessionTabPerformer = async (isActive) => {
    if (localStream) {
      if (!isActive) {
        localStream.getTracks().forEach((track) => {
          track.stop();
          localStream.removeTrack(track);
        });
        setLocalStream(null);
      }
    }
  };

  const handleSessionTabUser = (isActive) => {
    if (localStream) {
      if (!isActive) {
        localStream.getTracks().forEach((track) => track.stop());
      }
    }
  };

  const handleMediaPermissionOfUser = (payload) => {
    socket.emit(Face2FaceEvents.USER_MEDIA_PERMISSION_STATUS_SEND_TO_PERFORMER, payload);
  };

  const sendTipNotificationToPerformer = (payload, toggleModal) => {
    socket.emit(Face2FaceEvents.SEND_F2F_TIP_NOTIFICATION_TO_PERRFORMER, payload, (error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        toggleModal();
      }
    })
  }

  const toggleMute = () => {
    if (localStream) {
      const audioTracks = localStream.getAudioTracks();
      audioTracks.forEach((track) => {
        track.enabled = isMuted;
        if (isMuted) {
          track.applyConstraints({ echoCancellation: true });
        }
      });
      setIsMuted(!isMuted);
      updateAudioVedioToTableSetting('audio', !isMuted);
    }
  };

  const checkReceiverStatusOnCall = (payload) => {
    if (peerRef.current) {
      try {
        if (typeof peerRef.current.destroy === 'function') {
          peerRef.current.destroy();
        }
      } catch (error) {
        console.warn('Error destroying peer:', error);
      }
      peerRef.current = null;
    }
    if (peerConnection) {
      try {
        if (typeof peerConnection.destroy === 'function') {
          try {
        if (typeof peerConnection.destroy === 'function') {
          peerConnection.destroy();
        }
      } catch (error) {
        console.warn('Error destroying peer connection:', error);
      }
        }
      } catch (error) {
        console.warn('Error destroying peer connection:', error);
      }
    }
    socket && socket.emit(Face2FaceEvents.CHECK_PERFORMER_ACTIVE_ON_CALL_STATUS, payload)
  };

  const sendRejoinNotificationToUser = (payload) => {
    socket.emit(Face2FaceEvents.SEND_REJOIN_NOTIFICATION_TO_USER_FROM_PERFORMER, payload, (sessionId, error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        setShowWitingModal(false);
        setShowCallDisconnectModal(false);
        setIsConnecting(true);
        setCurrentSessionId(sessionId);
        props.dispatch(createNotification(getSuccessNotificationMessage('Notification sent')));
      }
    })
  };

  const sendRejoinNotificationToPerformer = (payload) => {
    socket.emit(Face2FaceEvents.SEND_REJOIN_NOTIFICATOIN_TO_PERFORMER_FROM_USER, payload, (sessionId, error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        setIsConnecting(true)
        setShowWitingModal(false);
        setShowCallDisconnectModal(false);
        setCurrentSessionId(sessionId);
        props.dispatch(createNotification(getSuccessNotificationMessage('Notification sent')));
      }
    })
  };

  const sendRejoinResponseToUserFromPerformer = (payload) => {
    socket.emit(Face2FaceEvents.SEND_REJOIN_NOTIFICATOIN_RESPONSE_TO_USER_FROM_PERFORMER, payload, (sessionId, error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        setCallAccepted(true);
        setIsConnecting(true);
        setIsCallAccepted(true);
        navigate(`/call-f2f?session=${sessionId}`);
        setCurrentSessionId(sessionId);
        props.dispatch(createNotification(getSuccessNotificationMessage('Call resuming')));
      }
    });
  };

  const sendRejoinResponseToPerformerFromUser = (payload) => {
    socket.emit(Face2FaceEvents.SEND_REJOIN_NOTIFICATION_RESPONSE_TO_PERFORMER_FROM_USER, payload, (sessionId, error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        setCallAccepted(true);
        setIsConnecting(true);
        setIsCallAccepted(true);
        navigate(`/user-call-f2f?session=${sessionId}`);
        checkReceiverStatusOnCall({
          sessionId: sessionId
        });
        setCurrentSessionId(sessionId);
        props.dispatch(createNotification(getSuccessNotificationMessage('Call resuming')));
      }
    })
  };

  const sendRefundReport = (payload) => {
    socket.emit(Face2FaceEvents.SEND_REPORT_AND_END_CALL_BY_USER, payload, (sessionId, error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        isCallDisconnectingRef.current = true
        setCurrentSessionId(sessionId);
        props.dispatch(createNotification(getSuccessNotificationMessage('Report sended')));
        endCallAutomatic();
      }
    });
  };

  const toggleVideoVisibility = () => {
    if (localStream) {
      const videoTracks = localStream.getVideoTracks();
      videoTracks.forEach((track) => {
        track.enabled = isVideoHidden;
      });

      setIsVideoHidden(!isVideoHidden);
      updateAudioVedioToTableSetting('camera', !isVideoHidden);
    }
  };

  const switchCamera = async () => {
    try {
      if (localStream) {
        const currentFacingMode = facingMode == 'user' ? 'environment' : 'user';

        const currentTrack = localStream.getVideoTracks();
        // Stop sending track to peers
        currentTrack.forEach((t) => t.stop());

        const constraints = { ...videoQuality };
        constraints.video.facingMode = currentFacingMode;
        const newStream = await navigator.mediaDevices.getUserMedia(constraints);

        localStream.removeTrack(currentTrack[0]);
        localStream.addTrack(newStream.getVideoTracks()[0]);
        // replace track to all peers
        peerRef.current.replaceTrack(currentTrack[0], newStream.getVideoTracks()[0], localStream);

        setfacingMode(currentFacingMode);
        updateAudioVedioToTableSetting('facingMode', currentFacingMode);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const extendCallRequestByUser = (payload, toggleModal) => {
    socket.emit(Face2FaceEvents.CALL_EXTEND_REQUEST_BY_USER, payload, (error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        props.dispatch(createNotification(getSuccessNotificationMessage('Request Sended!')));
        toggleModal();
      }
    });
  };

  const declineExtendCallRequestByPerformer = (payload) => {
    setCallExtendRequest({
      isOpen: false,
      package: {},
      callerData: {},
    });
    props.dispatch(
      createNotification(
        getSuccessNotificationMessage('Call Extend Request Declined Successfully'),
      ),
    );
    socket.emit(Face2FaceEvents.CALL_EXTEND_REQUEST_DICLINE_BY_PERFORMER, payload);
  };

  const extendCallRequestAcceptedByPerformer = (payload) => {
    socket.emit(Face2FaceEvents.CALL_EXTEND_REQUEST_ACCEPT_BY_PERFORMER, payload, (sessionData, error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        setCallExtendRequest({
          isOpen: false,
          package: {},
          callerData: {},
        });
        setExtenCallTime(sessionData?.extended_time);
        props.dispatch(
          createNotification(getSuccessNotificationMessage('Call Extend Successfully')),
        );
      }
    });
  };

  const unAcceptedCallCuTByUser = (payload) => {
    socket.emit(Face2FaceEvents.UNACCEPTED_CALL_CUTBY_USER, payload, (error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        isCallDisconnectingRef.current = true
        peerDestroy();
        endCallAutomatic();
      }
    });
  };

  const callRequestTimedOut = (sessionId) => {
    socket.emit(Face2FaceEvents.CALL_REQUEST_TIMED_OUT, {
      sessionId,
    }, (error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        props.dispatch(
          createNotification(getErrorNotificationMessage('Your call received no response')),
        );
        setShowSendMessageModal(true);
      }
    });
  };

  const endCallAcceptedByUser = (payload, toggle) => {
    payload.remaingTime = remaingTime;
    isCallDisconnectingRef.current = true
    socket.emit(Face2FaceEvents.ACCEPTED_CALL_END_BY_USER, payload, (error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        reasonForCallEndingRef.current = 'Call Ended Successfully'
        toggle(false);
        setShowConnectModalUser(false);
      }
    });
  };

  const reconnectPeer = (peerConection, call_status, id) => {
    if (peerConection) {
      // You might want to add some conditions or checks before re-initiating the peer connection
      // to avoid potential infinite loops or unwanted reconnections.
      if (call_status == 'calling') {
        setCallAccepted(true);
        setIsConnecting(true);
        startCameraPerofmer(id);
        clearInterval(reConnectRef.current);
      } else if (call_status === 'ongoing') {
        // acceptCall(currentSessionId, localStream, remotePeer);
      }
    }
  };

  useEffect(() => {
    return () => {
      clearInterval(reConnectRef.current);
    };
  }, []);

  const updateAudioVedioToTableSetting = (type, value) => {
    const session_data = JSON.parse(localStorage.getItem('session_data')) || {};
    const setting = { ...session?.single_session?.data?.data?.settings };
    if (session_data.userType == 'recevier') {
      if (type == 'audio') {
        setting.receiver.isMuted = value;
      } else if (type == 'facingMode') {
        setting.receiver.facing_mode = value;
      } else if (type == 'speaker') {
        setting.receiver.isSpeaker = value;
      } else {
        setting.receiver.isVideoHidden = value;
      }
    } else {
      if (type == 'audio') {
        setting.caller.isMuted = value;
      } else if (type == 'speaker') {
        setting.caller.isSpeaker = value;
      } else if (type == 'facingMode') {
        setting.caller.facing_mode = value;
      } else {
        setting.caller.isVideoHidden = value;
      }
    }
    saveToLocalStorage('setting', setting);

    socket.emit(Face2FaceEvents.UPDATE_SETTING_IN_SESSION, {
      sessionId: currentSessionId,
      setting,
    });
  };

  const handleSpeakerSetting = () => {
    setIsSpeaker(!isSpeaker);
    updateAudioVedioToTableSetting('speaker', !isSpeaker);
  };

  const handleLeaveCall = () => {
    socket.emit(Face2FaceEvents.LEAVE_CALL_DUE_TO_CALL_DISCONNECTED_AND_TRING_TO_RECONNECT, {
      sessionId: sessionDataSave.id,
    });

    isCallDisconnectingRef.current = true
    props.dispatch(createNotification(getSuccessNotificationMessage('Call Disconected')));
    peerDestroy();
    endCallAutomatic();
  };

  const handleStayOnCall = () => {
    setShowCallDisconnectModal(false);
    handleaddTimeToWaiting();
    setShowCallDisconnectModalTime(null);
    socket.emit(Face2FaceEvents.STAY_ON_CALL_WHILE_CALL_TRING_TO_RECONNECT, {
      sessionId: sessionDataSave.id,
    });
  };

  const handleaddTimeToWaiting = () => {
    setCallDisconnectedWaiting('00:30');
  };

  const handleCameraPermissionDeniedInRecevierSide = (message, sessionId) => {
    setCallAccepted(false);
    setCallPermisionDenied({
      ...callPermisionDenied,
      isOpen: true,
    });
    localStorage.setItem('session_data', JSON.stringify({}));
    socket.emit(Face2FaceEvents.CAMERA_PERMISSION_ERROR_IN_RECEIVER_SIDE, {
      sessionId: sessionId,
      message: `${message} in receiver side`,
    });
    return;
  };

  const handleCameraPermissionDeniedInCallerSide = (message, sessionId) => {
    setCallAccepted(false);
    setCallPermisionDenied({
      ...callPermisionDenied,
      isOpen: true,
    });
    localStorage.setItem('session_data', JSON.stringify({}));
    socket.emit(Face2FaceEvents.CAMERA_PERMISSION_ERROR_IN_CALLER_SIDE, {
      sessionId: sessionId,
      message: `${message} in caller side`,
    });
    return;
  };

  const endCallAutomaticWhenErrorOccuredInCallerSide = (message) => {
    if (peerConnection) {
      try {
        if (typeof peerConnection.destroy === 'function') {
          peerConnection.destroy();
        }
      } catch (error) {
        console.warn('Error destroying peer connection:', error);
      }
    }
    if (localStream) {
      localStream.getTracks().forEach((track) => track.stop());
    }
    setLocalStream(null);
    setRmoteStream(null);
    setPeerConnection(null);
    setCallStatus('idle');
    setIsMuted(false);
    setIsVideoHidden(false);
    setCurrentSessionId(null);
    setStartTime(false);
    setIsMessageNotification(false);
    setExtenCallTime(null);
    setCallExtendRequest({
      isOpen: false,
      package: {},
      callerData: {},
    });
    setConnectionStatusOffline(false);
    setIsConnecting(false);
    setShowCallDisconnectModal(false);
    setShowCallDisconnectModalTime(null);
    setCallAccepted(false);
    setCallDisconnectedWaiting(null);
    localStorage.setItem('session_data', JSON.stringify({}));
    setCallPermisionDenied({
      ...callPermisionDenied,
      isOpen: false,
      message: 'User Camera & microphone  permission is denied',
    });
    // window.location.reload()
  };

  const handleSendMessageToUser = (id, chatroomId) => {
    socket.emit(Face2FaceEvents.SEND_MESSAGE_TO_USER_BY_PERFORMER, { sessionId: id }, (response, error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        navigate(`/inbox?room=${chatroomId}`);
      }
    });
  };

  const endCallByUserDueToPerformerSendMsg = (payload, setLoading, chatRoomId) => {
    socket.emit(Face2FaceEvents.UNACCEPTED_CALL_CUTBY_USER, payload, (error) => {
      if (error) {
        handleAcknowledgementError(error);
      } else {
        props.dispatch(
          createNotification(getSuccessNotificationMessage('Call Disconnected Successfully ')),
        );
        setLoading(false);
        navigate(`/inbox?room=${chatRoomId}`);
        if (peerConnection) {
          try {
        if (typeof peerConnection.destroy === 'function') {
          peerConnection.destroy();
        }
      } catch (error) {
        console.warn('Error destroying peer connection:', error);
      }
        }
        if (localStream) {
          localStream.getTracks().forEach((track) => track.stop());
        }
        setLocalStream(null);
        setRmoteStream(null);
        setPeerConnection(null);
        setCallStatus('idle');
        setIsMuted(false);
        setIsVideoHidden(false);
        setCurrentSessionId(null);
        setStartTime(false);
        setExtenCallTime(null);
        setIsMessageNotification(false);
        setCallExtendRequest({
          isOpen: false,
          package: {},
          callerData: {},
        });
        setConnectionStatusOffline(false);
        setIsConnecting(false);
        setShowCallDisconnectModal(false);
        setShowCallDisconnectModalTime(null);
        setCallDisconnectedWaiting(null);
        setIsSwitchFeed(false);
        localStorage.setItem('session_data', JSON.stringify({}));
        setCallAccepted(false);
      }
    });
  };

  const handleSwitchFeed = () => {
    if (!isSwitchFeed) {
      localVideoRef.current.srcObject = remoteStream;
      remoteVideoRef.current.srcObject = localStream;
    } else {
      localVideoRef.current.srcObject = localStream;
      remoteVideoRef.current.srcObject = remoteStream;
    }
    setIsSwitchFeed(!isSwitchFeed);
  };

  const checkAllPermission = async () => {
    const checkPermission = await PermissionService.handlePermission(handlePermissionModal);
    if (!checkPermission) {
      setHasAllPermission(false);
      return false;
    } else {
      setHasAllPermission(true);
      setIsCallPermissionModalOpen({
        isOpen: false,
        message: null,
      });
      return true;
    }
  };

  // Get RTC Stats
  const getRTCStats = async () => {
    try {
      const stats = await new Promise((resolve, reject) => {
        peerConnection.readable && peerConnection.getStats((err, stats) => {
          if (err) reject(err);
          resolve(stats);
        });
      });
      const outBoundObject = {};
      const inBoundObject = {};
      const events = [];

      stats.forEach((report) => {
        if (report.type === 'outbound-rtp') {
          if (report.mediaType === 'audio') {
            Object.assign(outBoundObject, {
              audiobytesSent: report.bytesSent,
            });
          } else {
            Object.assign(outBoundObject, {
              videobytesSent: report.bytesSent,
              type: 'outbound-rtp',
              frameHeight: report.frameHeight,
              frameWidth: report.frameWidth,
              framesEncoded: report.framesEncoded,
              framesPerSecond: report.framesPerSecond,
              framesSent: report.framesSent,
              videoHeaderBytesSent: report.headerBytesSent,
            });
          }
        } else if (report.type === 'inbound-rtp') {
          if (report.mediaType === 'audio') {
            Object.assign(inBoundObject, {
              audiobytesReceived: report.bytesReceived,
            });
          } else {
            Object.assign(inBoundObject, {
              videobytesReceived: report.bytesReceived,
              type: 'inbound-rtp',
              frameHeight: report.frameHeight,
              frameWidth: report.frameWidth,
              framesDecoded: report.framesDecoded,
              framesPerSecond: report.framesPerSecond,
              framesReceived: report.framesReceived,
              videoHeaderBytesReceived: report.headerBytesReceived,
            });
          }
        }
      });
      events.push(inBoundObject);
      events.push(outBoundObject);
      socket.emit(Face2FaceEvents.FACE2FACE_CALL_STATS, {
        session_id: currentSessionId,
        events: events,
      });
    } catch (error) {
      getErrorNotificationMessage(error?.message);
      throw error;
    }
  };

  useEffect(() => {
    statsIntervalRef.current = setInterval(() => {
      if (peerConnection) {
        getRTCStats();
      } else {
        clearInterval(statsIntervalRef.current);
      }
    }, 5000);

    return () => {
      clearInterval(statsIntervalRef.current);
    };
  }, [peerConnection]);

  return (
    <SocketContext.Provider
      value={{
        socket,
        connected,
        connect,
        setConnected,
        showCallNotification,
        setCallNotification,
        callDeclineByPerformer,
        callUserDecline,
        setUserCallDeclien,
        localStream,
        localVideoRef,
        initiateCallF2FConection,
        startCameraPerofmer,
        remoteVideoRef,
        toggleMute,
        isMuted,
        toggleVideoVisibility,
        isVideoHidden,
        isCallAccepted,
        setCallAccepted,
        saveToLocalStorage,
        startTime,
        endCallByPerformer,
        handleUpadteRemaingTime,
        endCallTimeComplete,
        extendCallRequestByUser,
        callExtendRequestData,
        declineExtendCallRequestByPerformer,
        extendCallRequestAcceptedByPerformer,
        setExtenCallTime,
        extendedCallTime,
        unAcceptedCallCuTByUser,
        endCallAcceptedByUser,
        setRemaningTime,
        isSpeaker,
        handleSpeakerSetting,
        switchCamera,
        hanleInitializeCall,
        setStartTime,
        setConnectionStatusOffline,
        showCallDisconnectModal,
        showCallDisconnectModalTime,
        handleLeaveCall,
        handleStayOnCall,
        setSessionDataSave,
        callPermisionDenied,
        setCallPermisionDenied,
        handleSendMessageToUser,
        isMessageNotification,
        setIsMessageNotification,
        endCallByUserDueToPerformerSendMsg,
        handleSwitchFeed,
        checkActiveTabOfUsers,
        handleSessionTabUser,
        handleSessionTabPerformer,
        userActiveVideoStatus,
        performerActiveVideoStatus,
        checkActiveTabOfPerformer,
        showConnectModalUser,
        setShowConnectModalUser,
        showConnectModalPerformer,
        setShowConnectModalPerformer,
        startPerfomerCameraAfterVideoStatus,
        isConnecting,
        checkPerformerConnectingStatus,
        remainingTimeOfUser,
        isCallPermissionModalOpen,
        setIsCallPermissionModalOpen,
        hasAllPermission,
        checkAllPermission,
        handleMediaPermissionOfUser,
        isMediaPermissionUser,
        isSwitchFeed,
        showWaitingModal,
        setShowWitingModal,
        endCallFromPerformerWhenUserInactive,
        endCallFromUserWhenPerformerInactive,
        setIsCallAccepted,
        callAccepted,
        showSendMessageModal,
        setShowSendMessageModal,
        callRequestTimedOut,
        startUserTimerWithPerformer,
        startUserTimer,
        sendTipNotificationToPerformer,
        isCallDisconnecting: isCallDisconnectingRef.current,
        starPerformerTimer,
        setIsConnecting,
        checkReceiverStatusOnCall,
        sendRejoinNotificationToUser,
        sendRejoinNotificationToPerformer,
        setShowCallDisconnectModal,
        sendRejoinResponseToUserFromPerformer,
        sendRejoinResponseToPerformerFromUser,
        sendRefundReport
      }}
    >
      {children}
    </SocketContext.Provider>
  );
}

const mapStateToPros = (state) => ({
  session: state.Session,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(SocketProvider);
